import React from 'react';

import { Alert, Box, CircularProgress } from '@mui/material';

import FieldHistoryTable from './FieldHistoryTable';
import type { FieldHistoryEntry } from './types';

interface Props {
  emptyMessage?: string;
  entries: Array<FieldHistoryEntry>;
  error?: Error | null;
  isLoading?: boolean;
}

export default function FieldHistoryBody({ emptyMessage, entries, error, isLoading }: Props) {
  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
        <CircularProgress size={24} />
      </Box>
    );
  }
  if (error) {
    return (
      <Alert severity="error" sx={{ m: 2 }}>
        Could not load the history: {error.message}
      </Alert>
    );
  }
  return <FieldHistoryTable emptyMessage={emptyMessage} entries={entries} />;
}
